<template>
  <div>
    <b-container>
      <little-bar :current="current" :navlist="navlist" copyright="forum" @changeCurrent="changeCurrent">
        <template v-slot:right-nav>
          <div class="right">
            <div class="term-btn">
              <div class="text">
                <div>{{$t('lang.Year')}}：{{yearsel}} </div>
                <b-icon class="arrow" icon="chevron-down"></b-icon>
              </div>
              <div class="drop-down">
                <div class="drop-item" v-for="(value, index) in dateDrop" :key="index" @click="yearsel = value">
                  {{ value }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </little-bar>
      <keep-alive>
        <router-view />
      </keep-alive>
    </b-container>
  </div>
</template>
<script>
  import littleBar from "@/forumcomponents/littleBar";

  export default {
    components: {
      littleBar,
    },
    data() {
      return {
        current: 0,
        currentName: "",
        navlist: [{
          // text: '最新资讯',
          text: this.$t("lang.LatestNews"),
          path: "/forum/news/lastest?index=0",
        }, ],
        yearsel: 'ALL',
        dateDrop: [],
      };
    },
    mounted() {
      this.getNav()
      this.getYear()
    },
    watch: {
      yearsel(val) {
        this.$router.push({ 
          path: this.$route.fullPath,
          query: {
            type: this.type,
            year: this.yearsel == 'ALL' ? '' : this.yearsel,
          },
        });
      }
    },
    methods: {
      showDropDown() {
        this.show = !this.show;
      },
      changeCurrent(index, path) {
        this.current = index;
        this.$router.push(path);
      },
      getYear() {
        var nowDate = new Date();
        let isyear = nowDate.getFullYear();
        //计算获取最近六年
        for (let index = 1; index <= 8; index++) {
          this.dateDrop.push(isyear - 8 + index);
        }
        this.dateDrop.reverse()
        this.dateDrop.unshift('ALL')
      },
      getNav() {
        //获取小导航
        this.$forumApi.newsCategoryPageList().then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id == 6 ||res.data[i].id==3) {//AI+科学系列  &  Media Coverage，跳转list.vue
              this.navlist.push({
                text: res.data[i].name,
                id: res.data[i].id,
                path: `/forum/news/list?index=${i+1}&typeId=${res.data[i].id}`,
              });
              continue;
            }
            this.navlist.push({
              text: res.data[i].name,
              id: res.data[i].id,
              path: `/forum/news/lastest?index=${i+1}&typeId=${res.data[i].id}`,
            });

          }
        });
        
        // this.$forumApi.newsCategoryPageList().then((res) => {
        //   if (res.code == 200) {
        //     console.log("newsList", res.data);
        //     res.data.forEach((item,index)=>{
        //       this.navlist.push({
        //         text:item.name,
        //         id:item.id,
        //         path:`/forum/news/lastest?index=${index+1}&typeId=${item.id}`,
        //       })
        //     })
        //     this.navlist.map((item,index)=>{
        //       if(item.id==4){
        //         item.path=`/forum/news/list?index=${index}&typeId=${item.id}`
        //         }
        //     })
        //     console.log(' this.navlist', this.navlist);
        //   }
        // });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .term-btn {
    margin-left: 1rem;
    cursor: pointer;

    .text {
      display: flex;
      align-items: center;
    }

    .drop-down {
      height: 18rem;
      display: none;
    }
    .drop-item{
      height: 3rem;
    }
  }

  .term-btn:hover {
    .drop-down {
      position: relative;
      display: block;
      background-color: #f2f2f2;
      z-index: 99;
      text-align: center;

      .drop-item:hover {
        color: $forum-theme-blue;
        cursor: pointer;
      }
    }
  }
</style>